// src/components/NetSuiteWarnings.js
import React from 'react';
import { Alert } from 'react-bootstrap';

const NetSuiteWarnings = ({ warnings, onDismiss }) => {
  if (!warnings || warnings.length === 0) {
    return null;
  }

  // Parse warnings to extract meaningful information
  const parseWarning = (warning) => {
    const lowerWarning = warning.toLowerCase();
    
    // Determine warning type and icon
    let type = 'warning';
    let icon = 'bi-exclamation-triangle';
    let title = 'NetSuite Warning';
    
    if (lowerWarning.includes('overdue')) {
      type = 'danger';
      icon = 'bi-exclamation-octagon';
      title = 'Customer Overdue';
    } else if (lowerWarning.includes('credit limit')) {
      type = 'danger';
      icon = 'bi-credit-card';
      title = 'Credit Limit Exceeded';
    } else if (lowerWarning.includes('reorder')) {
      type = 'warning';
      icon = 'bi-arrow-repeat';
      title = 'Inventory Reorder Alert';
    }
    
    return { type, icon, title, message: warning };
  };

  const groupedWarnings = warnings.map(parseWarning);

  return (
    <div className="netsuite-warnings mb-4">
      {groupedWarnings.map((warning, index) => (
        <Alert 
          key={index} 
          variant={warning.type} 
          dismissible={!!onDismiss}
          onClose={onDismiss}
          className="mb-2"
        >
          <div className="d-flex align-items-start">
            <div className="flex-shrink-0 me-3">
              <i className={`bi ${warning.icon}`} style={{ fontSize: '1.5rem' }}></i>
            </div>
            <div className="flex-grow-1">
              <Alert.Heading as="h6" className="mb-2">
                <i className="bi bi-cloud me-2"></i>
                {warning.title}
              </Alert.Heading>
              <div className="mb-0" style={{ fontSize: '0.9rem' }}>
                {warning.message}
              </div>
            </div>
          </div>
        </Alert>
      ))}
      
      {groupedWarnings.length > 1 && (
        <div className="text-center mt-2">
          <small className="text-muted">
            <i className="bi bi-info-circle me-1"></i>
            {groupedWarnings.length} warnings from NetSuite
          </small>
        </div>
      )}
    </div>
  );
};



export default NetSuiteWarnings;